import { createAction } from '@ngrx/store';
import { createAsyncAction, createAsyncActionNoProps } from '@hglobal/common';
import { Balance } from '@pt/models';

import { balanceFeatureKey } from './balances.state';
import {
  ApplyBalanceSkinReq,
  ApplyBalanceSkinRes,
  GetBalanceRes,
  GetBalanceSkinsRes,
  GetCategoriesRes,
} from '../models';

const init = createAction(`[${balanceFeatureKey}]: Init`);
const getBalanceReq = createAsyncActionNoProps<GetBalanceRes>(
  `[${balanceFeatureKey}]: Get balance req`,
);
const getTeamBalanceReq = createAsyncActionNoProps<GetBalanceRes>(
  `[${balanceFeatureKey}]: Get team balance req`,
);
const getBalanceSkinsReq = createAsyncActionNoProps<GetBalanceSkinsRes, Balance>(
  `[${balanceFeatureKey}]: Get balance skins req`,
);
const applySkinReq = createAsyncAction<ApplyBalanceSkinReq, ApplyBalanceSkinRes>(
  `[${balanceFeatureKey}]: Apply skin req`,
);
const getCategoriesReq
  = createAsyncActionNoProps<GetCategoriesRes>(`[${balanceFeatureKey}]: Get categories`);

export const BalanceActions = {
  init,
  getBalanceReq,
  getTeamBalanceReq,
  getBalanceSkinsReq,
  applySkinReq,
  getCategoriesReq,
};
